import { useSelector } from "react-redux";

/**
 * Funzione che dato un array di oggetti companies ritorna l'elemento che contiene classifier studio.
 * Allo stato attuale se un utente è di tipo studio contiene almeno un classifier STUDIO nell'array companies
 * Per quanto debole questa assunzione al momento è l'unica possibile per discriminare un utente dello
 * studio da uno dell'azienda cliente
 * @param {Array} companiesArray: l'array di oggetti companies nel quale si vuole cercare il classifier di tipo STUDIO
 *
 */
export function getClassifierStudio(companiesArray) {
  return companiesArray.find((el) => {
    return el.classifier === "STUDIO";
  });
}

/**
 *
 * @param {Array} companiesArray: l'array di oggetti companies che si vuole filtrare con classifier dello stesso tipo
 * @param {string} classifierType: il tipo di classifier da filtrare. Al momento possibili STUDIO o COMPANY
 */
export function filterClassifier(companiesArray, classifierType) {
  return companiesArray.filter((el) => {
    return el.classifier === classifierType;
  });
}

/**
 *
 * @param {Array} companiesArray: l'array di oggetti companies che si vuole filtrare con classifier dello stesso tipo
 * @param {string} classifierType: il tipo di classifier da filtrare.
 */
export function filterNOTInClassifier(companiesArray, classifierType) {
  return companiesArray.filter((el) => {
    return el.classifier !== classifierType;
  });
}

export function getCompanyName(companies, fiscalCode) {
  return companies.find((el) => {
    return el.codiceFiscale === fiscalCode;
  }).ragioneSociale;
}

export const GetSelectedCompanyStudio = () => {
  const studio = useSelector((state) => state.studio);
  const main = useSelector(state => state.main);
  const company = useSelector((state) => state.company);
  
  let studioFind;

  if (main?.accountantUuidSelected) {
    studioFind = studio?.list?.find((x) => x.uuid === main?.accountantUuidSelected) ||
    company?.companies?.find(x => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find(x => x?.uuid === main?.accountantUuidSelected);
  }

  return studioFind;
};
